import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { createElementBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, unref } from "vue";
var ScalarSidebarGroupToggleSpacer_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarSidebarGroupToggleSpacer",
	setup(__props) {
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(unref(cx)("h-4 w-5"))), null, 16);
		};
	}
});
//#endregion
export { ScalarSidebarGroupToggleSpacer_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarSidebarGroupToggleSpacer.vue_vue_type_script_setup_true_lang.js.map